export const linkStyle = {
  '& a': {
    color: '#0078d4',
    textDecoration: 'none',
    cursor: 'pointer',
  },

  '& a:hover, a:active': {
    color: '#004578',
    textDecoration: 'underline',
  },

  '& a:focus': {
    outline: 'none',
    border: '1px solid #605E5C',
  },
};
